module.exports = {"440402001":"翠香街道","440402002":"梅华街道","440402003":"前山街道","440402004":"吉大街道","440402005":"拱北街道","440402006":"香湾街道","440402007":"狮山街道","440402008":"湾仔街道","440402009":"凤山街道","440402100":"唐家湾镇","440402102":"南屏镇","440402104":"横琴镇","440402105":"桂山镇","440402106":"万山镇","440402107":"担杆镇","440402401":"南屏科技园","440402402":"保税区","440402403":"三溪科创小镇发展中心","440402404":"洪湾商贸物流中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440402.json
// module id = 2101
// module chunks = 0